"use client";

import Menu from "@/components/menu/Menu";
import Logo from "@/components/elements/logo/Logo";
import SideNavModal from "@/components/sideNavModal/SideNavModal";
import type { GlobalSocial } from "@/lib/global";

type Props = {
  socials?: GlobalSocial[];
};

const Header = ({ socials }: Props) => {

  return (
    <header className="inner-container large2">
      <div
        className={
          "flex h-[100px] md:h-[120px] items-center gap-[20px] relative justify-between"
        }
      >
        <div className="w-[160px] sm:w-[200px] xl:w-auto flex-shrink-0">
          <Logo light={false} className="!w-full !h-auto" />
        </div>
        <div className="hidden xl:block">
          <Menu/>
        </div>
        <div className="flex gap-5 xl:hidden">
          {/* <Link
            className={cn(
              "wc-btn-underline text-[14px] font-medium tracking-normal pb-1 inline-flex gap-[10px]"
            )}
            href={"/contact"}
          >
            <span>Get Started</span>
            <FaArrowRightLong />
          </Link> */}
          <SideNavModal socials={socials} />
        </div>
      </div>
    </header>
  );
};

export default Header;
